import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoDangerouslyHtml } from 'components/no-auth/common/promo-dangerously-html/PromoDangerouslyHtml';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const SocialIconsContainer = styled.div`
    background: ${(props) => promoColors[props.bgColor]};
    padding: 32px 0;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: ${(props) => (props.noBottomMargin ? null : '32px')};

    h3 {
        word-break: break-word;
    }

    ${promoMedia.tablet744} {
        padding: 48px 0;
        margin-bottom: ${(props) => (props.noBottomMargin ? null : '48px')};
    }

    ${promoMedia.desktop1440} {
        padding: 64px 0;
        margin-bottom: ${(props) => (props.noBottomMargin ? null : '64px')};
    }
`;

const SocialIcons = styled.ul`
    display: inline-flex;
    flex-flow: row wrap;
    list-style-type: none;
    margin: ${(props) => (props.hasTitle ? '16px auto 0' : '0 auto')};
    justify-content: center;
    padding: 0;
    row-gap: 16px;

    ${promoMedia.tablet744} {
        margin-top: ${(props) => (props.hasTitle ? '24px' : null)};
    }

    ${promoMedia.desktop1440} {
        margin-top: ${(props) => (props.hasTitle ? '32px' : null)};
    }
`;
const SocialIcon = styled.li`
    min-width: 40px;
    width: 40px;
    padding: 0 12px;

    a {
        border-radius: 50%;
        display: inline-block;

        &:link {
            :focus-visible {
                background-color: ${promoColors.purple40};
                outline: 1px dashed ${promoColors.purple};
            }
        }
    }

    img {
        border: none;
        height: auto;
        max-width: 100%;
        vertical-align: top;
    }
`;

export const SocialMediaSection = ({ bgColor = 'transparent', ...props }) => {
    return (
        <>
            {props.socialIcons && (
                <SocialIconsContainer bgColor={bgColor} noBottomMargin={props.noBottomMargin}>
                    {props.socialTitle && <PromoDangerouslyHtml color={'baseColor'} dangerouslyHtml={props.socialTitle} tag="h2" variant={'h3'} />}
                    <SocialIcons hasTitle={props.socialTitle}>
                        {Array.isArray(props.socialIcons) &&
                            props.socialIcons
                                .filter((item) => item !== null)
                                .map((item) => {
                                    return (
                                        <SocialIcon key={item.id}>
                                            <a href={item.url} target="_blank">
                                                <img src={item.icon.url} height={item.icon.height} width={item.icon.width} alt={item.icon.alternativeText} />
                                            </a>
                                        </SocialIcon>
                                    );
                                })}
                    </SocialIcons>
                </SocialIconsContainer>
            )}
        </>
    );
};

SocialMediaSection.propTypes = {
    socialIcons: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
    socialTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    bgColor: PropTypes.oneOf(['baseColor', 'white', 'purple5', 'gray5', 'eggshell01', 'eggshell02', 'eggshell03', 'transparent']),
    noBottomMargin: PropTypes.bool,
};
